import React from 'react';
import ClientAgreementContainer from './ClientAgreementContainer';
import { ClientAgreementProvider } from './ClientAgreementContext';

const ClientAgreement = () => {
  return (
    <ClientAgreementProvider>
      <ClientAgreementContainer />
    </ClientAgreementProvider>
  );
};

export default ClientAgreement;
